import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class PageNextButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.pageNextButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M16,32A16,16,0,1,0,0,16,16,16,0,0,0,16,32ZM6,14H18.34L13.27,8.93,16.1,6.1l7.07,7.07L26,16l-2.83,2.83L16.1,25.9l-2.83-2.83L18.34,18H6V14Z" />
				</svg>
			</i>
		</Button>;
	}
}
